import React from "react";
import {
  FaLeaf,
  FaSubway,
  FaChair,
  FaUtensils,
  FaStore,
  FaDumbbell,
} from "react-icons/fa";
import "../Amenities/Amenities.css";
import { TbAirConditioning } from "react-icons/tb";

const Amenities = () => {
  return (
    <div className="amenities-section">
      <h2 className="head-am">
        Operational <span className="highlight"> Features</span>
      </h2>
      <div className="grid-container">
        {/* First row */}
        <div className="amenity-item">
          <div className="div-c">
            <FaLeaf className="icon-a" />
            <p className="p-a">
              <strong>'The Golden Petal'</strong> designed by Uncommon Land, UK,
              adorns the large central atrium of the mall
            </p>
          </div>
          <img className="img-a" src="gp.webp" alt="Golden Petal" />
        </div>
        <div className="amenity-item">
          <img className="img-a" src="ee.webp" alt="Escalator" />
          <div className="div-c">
            <FaUtensils className="icon-a" />
            <p className="p-a">
              Express escalator exclusively for the food court
            </p>
          </div>
        </div>

        {/* Second row */}
        <div className="amenity-item">
          <img className="img-a" src="6p.webp" alt="Entry points" />
          <div className="div-c">
            <p className="p-a">
              6 independent entry/exit and drop-off points for retail,
              hotel/banquets, and offices
            </p>
            <TbAirConditioning className="icon-a" />
          </div>
        </div>
        <div className="amenity-item">
          <div className="div-c">
            <FaSubway className="icon-a" />
            <p className="p-a">Upcoming Metro station in front of the mall</p>
          </div>
          <img className="img-a" src="uc.webp" alt="Metro station" />
        </div>

        {/* Third row */}
        <div className="amenity-items">
          <div className="anchors-gridd">
            <div className="div-c">
              <FaStore className="icon-a" />
              <p className="p-a">6 large anchors with road frontage</p>
            </div>
            <img src="hm.webp" alt="Hypermarket" />
            <img src="aa.webp" alt="Apparel Anchor" />
            <img src="mp.webp" alt="Apparel Anchor" />
            <img src="hs.webp" alt="Digital Anchor" />
            <img src="ma.webp" alt="Home Store" />
          </div>
        </div>
        <div className="last-a">
          <div className="amenity-item">
            <div className="div-c">
              <FaChair className="icon-a" />
              <p className="p-a">
                Triple-height entertainment centre, Large landscaped terrace
                restaurants, Banquet hall with a capacity of 1500–2000 people
              </p>
            </div>
            <img className="img-a" src="ec.webp" alt="Entertainment centre" />
          </div>
          <div className="amenity-item">
            <img className="img-a" src="cr.webp" alt="Conference rooms" />
            <div className="div-c">
              <FaDumbbell className="icon-a" />
              <p className="p-a">
                Large conference rooms for all your meeting needs, Gym & spa to
                stretch out the overworked muscles
              </p>
            </div>
          </div>
        </div>

        {/* Fourth row */}
      </div>
    </div>
  );
};

export default Amenities;
